import { EStepCode } from '../../../types/form';
import { generateSkipSteps } from './generateSkipSteps';
import { IParseSkipStepsParams } from '../index';

export const getSkipStepsFromQueryParams = (
  formDataFromQs: IParseSkipStepsParams['formDataFromQs'],
): EStepCode[] | undefined =>
  formDataFromQs?.skipSteps?.[0]
    ? formDataFromQs.skipSteps
    : formDataFromQs?.formData && generateSkipSteps(formDataFromQs.formData);
